import InputTypeBasic from "./basic"
import InputTypeDetailed from "./detailed"
import DeleteConfirmation from "./delete-modal"
import InputPercentOfInflation from "./percent-of-inflation"

export default {
  InputTypeBasic,
  InputTypeDetailed,
  InputPercentOfInflation,
  DeleteConfirmation
}